import React from "react";

export default ({record}) => {
  return <span>Lien footer {record.label ? `"${record.label}"` : ''}</span>;
}
